var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.921,17.627c-1.104,0-2,0.896-2,2v22.456c0,1.104,0.896,2,2,2h22.456c1.104,0,2-0.896,2-2 C78.377,28.598,67.406,17.627,53.921,17.627z M55.921,40.083V21.725c9.687,0.944,17.415,8.672,18.359,18.358H55.921z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.17,46.29H49.715V25.834c0-1.104-0.896-2-2-2c-13.485,0-24.456,10.971-24.456,24.456s10.971,24.456,24.456,24.456 S72.17,61.774,72.17,48.29C72.17,47.185,71.274,46.29,70.17,46.29z M47.714,68.745c-11.279,0-20.456-9.177-20.456-20.456 c0-10.604,8.111-19.35,18.456-20.358V48.29c0,1.105,0.896,2,2,2h20.359C67.064,60.634,58.319,68.745,47.714,68.745z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.ecbe0de4dc88f34e1fdc2d16cdf53034.svg";
export { ForwardRef as ReactComponent };